﻿(function () {
  var GIFT_KEYS = ['Occasion', 'Destinataire', 'Message', 'Langue'];
  var EMOJI =
    /[\u{1F000}-\u{1FAFF}\u{2600}-\u{27BF}\u{2B00}-\u{2BFF}\u{2300}-\u{23FF}\u{FE00}-\u{FE0F}\u{1F1E6}-\u{1F1FF}\u{200D}\u{20E3}]/gu;

  function getCartRoot() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
  }

  function getRoute(name, fallback) {
    return window.routes && window.routes[name] ? window.routes[name] : fallback;
  }

  function showStatus(root, message, isError) {
    var status = root.querySelector('[data-gift-status]');
    if (!status) return;
    status.textContent = message || '';
    status.classList.toggle('is-error', Boolean(isError));
  }

  function setBusy(root, busy) {
    root.querySelectorAll('[data-gift-save], [data-gift-remove]').forEach(function (button) {
      button.disabled = busy;
    });
  }

  function collectValues(root) {
    var values = {};
    root.querySelectorAll('[data-gift-field]').forEach(function (field) {
      values[field.dataset.giftField] = field.value.trim();
    });
    return values;
  }

  function collectQuantity(root, maximum) {
    var field = root.querySelector('[data-gift-quantity]');
    if (!field) return maximum;
    var quantity = parseInt(field.value, 10);
    if (!Number.isFinite(quantity)) return maximum;
    return Math.max(1, Math.min(quantity, maximum));
  }

  async function getCurrentLine(key) {
    var response = await fetch(getCartRoot() + 'cart.js', {
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) throw new Error('cart');
    var cart = await response.json();
    var item = cart.items.find(function (line) {
      return line.key === key;
    });
    if (!item) throw new Error('line');
    return item;
  }

  function renderCartSection(html) {
    if (!html) return;
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var incoming = parsed.querySelector('#main-cart-items .js-contents');
    var current = document.querySelector('#main-cart-items .js-contents');
    if (incoming && current) current.innerHTML = incoming.innerHTML;
  }

  async function updateGift(root, remove) {
    showStatus(root, '', false);
    var values = collectValues(root);

    if (!remove && !values.Occasion && !values.Destinataire && !values.Message) {
      showStatus(root, root.dataset.required, true);
      return;
    }

    setBusy(root, true);
    try {
      var item = await getCurrentLine(root.dataset.itemKey);
      var properties = Object.assign({}, item.properties || {});
      GIFT_KEYS.forEach(function (key) {
        delete properties[key];
      });
      delete properties._nida_standard;

      if (remove) {
        // Shopify n'accepte pas un objet properties vide après sa création.
        // Cette propriété privée retire les champs cadeau sans rien afficher au client.
        if (Object.keys(properties).length === 0) properties._nida_standard = 'true';
      } else {
        if (values.Occasion) properties.Occasion = values.Occasion;
        if (values.Destinataire) properties.Destinataire = values.Destinataire;
        if (values.Message) properties.Message = values.Message;
        properties.Langue = values.Langue || 'Français (FR)';
      }

      var giftQuantity = collectQuantity(root, item.quantity);
      if (!remove && giftQuantity < item.quantity) {
        var addItem = {
          id: item.variant_id,
          quantity: giftQuantity,
          properties: properties,
        };
        if (item.selling_plan_allocation) {
          addItem.selling_plan = item.selling_plan_allocation.selling_plan.id;
        }

        var addResponse = await fetch(getRoute('cart_add_url', getCartRoot() + 'cart/add.js'), {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ items: [addItem] }),
        });
        if (!addResponse.ok) {
          var addError = await addResponse.json();
          throw new Error(addError.description || 'add');
        }

        var splitResponse = await fetch(getRoute('cart_change_url', getCartRoot() + 'cart/change.js'), {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: item.key,
            quantity: item.quantity - giftQuantity,
            sections: ['main-cart-items'],
            sections_url: window.location.pathname,
          }),
        });
        var splitCart = await splitResponse.json();
        if (!splitResponse.ok) throw new Error(splitCart.description || 'split');

        renderCartSection(splitCart.sections && splitCart.sections['main-cart-items']);
        boot();
        return;
      }

      var response = await fetch(getRoute('cart_change_url', getCartRoot() + 'cart/change.js'), {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: item.key,
          quantity: item.quantity,
          properties: properties,
          sections: ['main-cart-items'],
          sections_url: window.location.pathname,
        }),
      });
      var cart = await response.json();
      if (!response.ok) throw new Error(cart.description || 'change');

      renderCartSection(cart.sections && cart.sections['main-cart-items']);
      boot();
    } catch (error) {
      showStatus(root, root.dataset.error, true);
      setBusy(root, false);
    }
  }

  function init(root) {
    if (root.dataset.nidaCartGiftReady) return;
    root.dataset.nidaCartGiftReady = 'true';

    // Le composant natif <cart-items> écoute tous les événements "change"
    // et les traite comme des quantités. On garde les changements cadeau locaux.
    root.querySelectorAll('[data-gift-field], [data-gift-quantity]').forEach(function (field) {
      field.addEventListener('change', function (event) {
        event.stopPropagation();
      });
    });

    root.querySelectorAll('[data-gift-clean]').forEach(function (input) {
      input.addEventListener('input', function () {
        input.value = input.value.replace(EMOJI, '');
        var counter = input.parentElement.querySelector('[data-gift-count]');
        if (counter) counter.textContent = input.value.length;
      });
    });

    var save = root.querySelector('[data-gift-save]');
    var remove = root.querySelector('[data-gift-remove]');
    if (save) save.addEventListener('click', function () { updateGift(root, false); });
    if (remove) remove.addEventListener('click', function () { updateGift(root, true); });
  }

  function boot() {
    document.querySelectorAll('[data-nida-cart-gift]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  var observer = new MutationObserver(boot);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
